
import React from 'react';

export const LoadingSpinner: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center space-y-2">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-t-2 border-[#002A5C]"></div>
            <p className="text-sm text-gray-500">AI is thinking...</p>
        </div>
    );
};
